import { useEffect, useState, type DependencyList } from "react";

/**
 * useAfterPaint
 *
 * Returns `true` after the next browser frame is painted following a React update.
 * Uses requestAnimationFrame + MessageChannel for cross-browser reliability.
 *
 * Based on: https://webperf.tips/tip/measuring-paint-time/
 */
export function useAfterPaint(deps: DependencyList = []) {
  const [hasPainted, setHasPainted] = useState(false);

  useEffect(() => {
    setHasPainted(false);
    let cancelled = false;
    requestAnimationFrame(() => {
      const messageChannel = new MessageChannel();
      messageChannel.port1.onmessage = () => {
        if (!cancelled) setHasPainted(true);
      };
      messageChannel.port2.postMessage(null);
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return hasPainted;
}
